import Swiper from "swiper";
import { Navigation, Keyboard } from "swiper/modules";
// import { debounce } from "../utils/Performance";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/keyboard";

export default class CardCarousel {
    constructor(element) {
        // Class properties.
        this.el = element;
        this.swiperEl = this.el.querySelector(".swiper");
        this.swiper = null;
        this.prevEl = this.el.querySelector(".cards__carousel-nav-prev");
        this.nextEl = this.el.querySelector(".cards__carousel-nav-next");

        this.init();
    }

    init() {
        this.initSwiper();

        // Responsive behavior.
        // this.initCarousel();

        // window.addEventListener(
        //     "resize",
        //     debounce(() => {
        //         this.initCarousel();
        //     }, 250),
        // );
    }

    // initCarousel() {
    //     if (window.matchMedia("(min-width: 768px)").matches) {
    //         if (!this.swiper) {
    //             this.initSwiper();
    //         }
    //     } else {
    //         this.swiper?.destroy();
    //     }
    // }

    initSwiper() {
        // Instantiate the carousel.
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 16,
            loopPreventsSliding: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            grabCursor: true,
            navigation: {
                nextEl: this.nextEl,
                prevEl: this.prevEl,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
            containerRole: `region`,
            containerRoleDescriptionMessage: `cards carousel`,
            modules: [Navigation, Keyboard],
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const cardCarousels = document.querySelectorAll(`[data-card-carousel]`);

    cardCarousels.forEach((element) => {
        new CardCarousel(element);
    });
});
